export default function InputForm({ value, onChange }) {
  return (
    <textarea
      placeholder="もやもやした言葉を入力"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      style={{ width: "100%", height: "80px", padding: "8px", fontSize: "16px" }}
    />
  );
}
